// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZHgZ","content":"styles_content__2kcUd","tableWrap":"styles_tableWrap__2ictT"};